<div class="mat-tab-body-content" #content [@translateTab]="_position" (@translateTab.start)="_onTranslateTabStarted($event)" (@translateTab.done)="_onTranslateTabComplete($event)"><ng-template matTabBodyHost></ng-template></div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/node_modules/@angular/material/tabs/typings/index.d.ts.MatTabBody.html